var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n      .st1{fill:#fff}\n   ")), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#2d8cff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.7 467.3c-12.3-12.3-28.4-18.5-44.7-18.5-16.1 0-32.4 6.2-44.7 18.5-24.7 24.7-24.7 64.6 0 89.4 24.7 24.7 64.6 24.7 89.4 0 24.7-24.6 24.7-64.8 0-89.4zm-17.8 71.6c-14.9 14.9-38.9 14.9-53.6 0-14.9-14.9-14.9-38.9 0-53.6 14.9-14.9 38.9-14.9 53.6 0 14.7 14.7 14.7 38.7 0 53.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.5 467.3c-12.3-12.3-28.4-18.5-44.7-18.5-16.1 0-32.4 6.2-44.7 18.5-24.7 24.7-24.7 64.6 0 89.4 24.7 24.7 64.6 24.7 89.4 0 24.6-24.6 24.6-64.8 0-89.4zm-17.9 71.6c-14.9 14.9-38.9 14.9-53.6 0-14.9-14.9-14.9-38.9 0-53.6 14.9-14.9 38.9-14.9 53.6 0 14.7 14.7 14.7 38.7 0 53.6zm-317.6 36 6.3.3h94.8l-.3-6.3c-.8-10.4-8.2-18-18.6-18.6l-6.3-.3H275l75.9-75.9-.3-6.3c-.5-10.4-8.2-18.2-18.6-18.6l-6.3-.3h-94.8l.3 6.3c.8 10.3 8.4 18 18.6 18.6l6.3.3H313l-76 75.8.3 6.3c.7 10.5 8.3 18.1 18.7 18.7zm432.7-88.2c2.2 3.8 2.8 7.9 3.2 12.6l.3 6.3v44.2l.3 6.3c.6 10.3 8.2 18 18.6 18.6l6.3.3v-69.5l.3-6.3c.3-4.7.9-9 3.2-12.8 4.4-7.6 12.5-12.5 21.8-12.5s17.5 5.1 22 12.6c2.2 3.8 2.8 8.1 3 12.6l.3 6.3v44.2l.3 6.3c.6 10.4 8.2 18 18.6 18.6l6.3.3V499c0-28-22.6-50.6-50.6-50.6-15.2 0-28.6 6.6-37.9 17.1-9.3-10.4-22.8-17.1-37.9-17.1-10.4 0-20.2 3.2-28.3 8.7-4.9-5.5-16-8.7-22.3-8.7v126.4l6.3-.3c10.6-.6 18.2-8.2 18.6-18.6l.3-6.3v-44.2l.3-6.3c.3-4.7.9-9 3.2-12.6 4.4-7.6 12.5-12.6 21.8-12.6 9.5.2 17.7 5.2 22 12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomSvgrepoCom);
export default __webpack_public_path__ + "static/media/zoom-svgrepo-com.93bc3183c86974352dafe2f5fa0ba5b5.svg";
export { ForwardRef as ReactComponent };